import { b64urlToUtf8 } from '@rms/sdk/base64';

import { AccessTokenClaims } from '../models';

export function decodeAccessToken(token: string): AccessTokenClaims | null {
  const payload = token.split('.')[1];

  if (!payload) {
    return null;
  }

  try {
    const claims: unknown = JSON.parse(b64urlToUtf8(payload));

    return isAccessTokenClaims(claims) ? claims : null;
  } catch {
    return null;
  }
}

export function isAccessTokenExpired(claims: Pick<AccessTokenClaims, 'exp'>, nowMs: number = Date.now()): boolean {
  return claims.exp * 1000 <= nowMs;
}

function isAccessTokenClaims(value: unknown): value is AccessTokenClaims {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  const claims = value as Partial<AccessTokenClaims>;

  return (
    typeof claims.exp === 'number' &&
    typeof claims.user_id === 'string' &&
    typeof claims.username === 'string' &&
    typeof claims.user_full_name === 'string' &&
    Array.isArray(claims.roles) &&
    claims.roles.every((role) => typeof role === 'string')
  );
}
